export default {
  id: 153,
  title: 'Target #153 - Checkers',
  url: 'https://cssbattle.dev/play/153',
  colors: ['#E3516E', '#FADE8B'],
  solution:
    '<a a><a b><style>body{background:#e3516e}a{position:fixed;background:#fade8b;color:#fade8b}[a]{top:50;left:100;width:40;height:40;box-shadow:80px 0,160px 0,40px 40px,120px 40px,0 80px,80px 80px,160px 80px,40px 120px,120px 120px,0 160px,80px 160px,160px 160px}[b]{top:60;left:150;width:20;height:20;border-radius:9in;box-shadow:80px 0,-40px 40px,40px 40px,120px 40px,-40px 120px,40px 120px,120px 120px,0 160px,80px 160px}</style>',
}
